import { render } from "./VideoDetail.vue?vue&type=template&id=7a1da66a&scoped=true"
import script from "./VideoDetail.vue?vue&type=script&lang=js"
export * from "./VideoDetail.vue?vue&type=script&lang=js"

import "./VideoDetail.vue?vue&type=style&index=0&id=7a1da66a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1da66a"]])

export default __exports__